import React, { useContext } from "react";
import ContainerBackgroundWrapper from "../components/Backgrounds"
import styled from "styled-components"
import { useNavigate } from "react-router"

import { Apis } from "../util/Apis"
import CustomLoading from "../components/CustomLoading"
import { SiteContext } from "../context/SiteContext";
import { getLogoURL } from "../util/logoUtils";
import { logoutUser } from "../login/LogoutPage";
import useGet from "../hooks/useGet";
import Button from "../components/atoms/Buttons";
import { syncSalaCurrencyConfig } from "../components/services";

const SelectorPage = styled.main`
  position: relative;
  height: 100%;
  overflow-y: auto;
  font-family: Arial, sans-serif;
  &, & * { box-sizing: border-box; }
`;
const SelectorToolbar = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 2;
  display: flex;
  justify-content: flex-end;
`;
const ExitButton = styled(Button).attrs({ variant: 'outline' })`
  padding: 10px 22px;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  text-transform: none;
`;
const SelectorContent = styled.section`
  padding: 24px clamp(16px, 3vw, 48px) 64px;
  @media (max-width: 699px) {
    padding-top: 76px;
  }
`;
const TitleSelector = styled.h1`
  margin: 0;
  text-align: center;
  color: #ffe6a1;
  font: 700 clamp(22px, 2.2vw, 34px)/1.2 Arial, sans-serif;
  text-shadow: 0 1px #b77a27, 0 2px 6px #21000080;
`;
const SalaList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 20px;
  max-width: 1160px;
  margin: 28px auto 0;
  @media (min-width: 700px) and (max-width: 1100px) {
    max-width: 570px;
  }
`;
const SalaCard = styled.article`
  cursor: pointer;
  transition: transform .15s ease, box-shadow .15s ease, border-color .15s ease;
  &:hover, &:focus-visible {
    transform: translateY(-3px);
    border-color: #ffe6a1;
    box-shadow: 0 16px 32px #16000077, 0 0 0 2px #ffe6a166, inset 0 1px 0 #ffe5a126;
    outline: none;
  }
  &:active {
    transform: translateY(0);
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc((100% - 60px) / 4);
  flex-shrink: 0;
  padding: 16px 14px 14px;
  border: 2px solid #c49a49;
  border-radius: 16px;
  background: linear-gradient(145deg, #00000099, #000000b8), ${({ theme }) => theme.homeBackground};
  box-shadow: 0 12px 28px #16000055, inset 0 1px 0 #ffe5a126;
  @media (min-width: 700px) and (max-width: 1100px) {
    width: calc((100% - 20px) / 2);
    max-width: 275px;
  }
  @media (max-width: 699px) {
    width: min(275px, 100%);
  }
`;
const SalaLogo = styled.img`
  display: block;
  width: 100%;
  max-width: 185px;
  height: 96px;
  object-fit: contain;
  margin: 2px 0 14px;
`;
const SalaName = styled.h2`
  margin: 0;
  color: #fff8ee;
  font: 700 clamp(16px, 1.2vw, 18px)/1.25 Arial, sans-serif;
  text-transform: uppercase;
  text-align: center;
  overflow-wrap: anywhere;
`;

const SalaSelector = () => {

  const navigate = useNavigate()

  const { loading, data } = useGet({
    url: Apis.USER + '/users/me?product=gaming',
    initialValue: null
  })

  const {setSalaId, setInfo, setCurrencyConfig} = useContext(SiteContext)

  const selectSala = async (sala) => {
    setSalaId(sala.id)
    setInfo({ sala: sala })

    localStorage.setItem('salaId', sala.id)
    localStorage.setItem('sala', JSON.stringify(sala))
    // Notifica a App para que actualice el tema sin refrescar la página
    window.dispatchEvent(new Event('salaChanged'))

    const config = await syncSalaCurrencyConfig(sala.id)
    setCurrencyConfig(config)

    navigate('/sorteo-list')
  }

  return (
    <ContainerBackgroundWrapper showBackgroundCard={false}>
      {!loading ?
        <SelectorPage className="custom-scroll" data-testid="sala-selector">
          <SelectorToolbar>
            <ExitButton onClick={logoutUser}>Cerrar sesión</ExitButton>
          </SelectorToolbar>
          <SelectorContent aria-labelledby="sala-selector-title">
            <TitleSelector id="sala-selector-title">SELECCIONA UNA SALA</TitleSelector>
            <SalaList>
              {data?.salas?.map((sala) =>
                <SalaCard
                  key={sala.id}
                  role="button"
                  tabIndex={0}
                  aria-label={`Seleccionar ${sala.name}`}
                  onClick={() => selectSala(sala)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault()
                      selectSala(sala)
                    }
                  }}
                >
                  <SalaLogo alt="" src={getLogoURL(sala.logo)} />
                  <SalaName>{sala.name}</SalaName>
                </SalaCard>
              )}
            </SalaList>
          </SelectorContent>
        </SelectorPage>
        :
        <CustomLoading />
      }
    </ContainerBackgroundWrapper>
  )
}

export default SalaSelector;
